<script setup lang="ts">
    import { useAuthStore } from '#imports';
    import { useRoleStore } from '#imports';

    /* Store variables */
    const { active_emp, profile } = storeToRefs(useAuthStore());
    const roleStore = useRoleStore();
    const { roles } = storeToRefs(roleStore);
    const { fetchRoles } = roleStore;

    await fetchRoles();
</script>

<template>
    <v-hover v-if="active_emp && active_emp.role && profile && profile.role_id === 1">
        <template v-slot:default="{ isHovering, props }">
            <v-select
                label="Pseudo Role"
                v-model="active_emp.role.id"
                v-bind="props"
                :items="roles"
                item-title="name"
                item-value="id"
                class="mr-3"
                max-width="128"
                :style="`opacity: ${isHovering ? '1' : '0'}; transition: 250ms;`"
                hide-details />
        </template>
    </v-hover>
</template>